{
  "aiGeneratedAnswer": "Respuesta generada por IA",
  "allCategories": "Todas las categorías",
  "appliedFiltersToCurrentSearch": "Filtros aplicados a la búsqueda actual",
  "apply": "Aplicar",
  "applyFilters": "Aplicar filtros",
  "autocompleteOptionsFound_many": "{{count}}{{label}} opciones de autocompletado encontradas.",
  "autocompleteOptionsFound_one": "{{count}}{{label}} opción de autocompletado encontrada.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} opciones de autocompletado encontradas.",
  "autocompleteSuggestion": "sugerencia de autocompleto: {{suggestion}}",
  "autocompleteSuggestionsFound_many": "{{count}} sugerencias de autocompletado encontradas.",
  "autocompleteSuggestionsFound_one": "{{count}} sugerencia de autocompletado encontrada.",
  "autocompleteSuggestionsFound_other": "{{count}} sugerencias de autocompletado encontradas.",
  "basedOnYourDevice": " (basado en tu dispositivo)",
  "basedOnYourInternetAddress": " (basado en tu dirección de internet)",
  "categoriesText_one": "La siguiente categoría produjo resultados para - <strong>{{query}}</strong>",
  "categoriesText_other": "Las siguientes categorías produjeron resultados para - <strong>{{query}}</strong>",
  "clearAll": "Borrar todo",
  "clearMinAndMax": "Borrar mínimo y máximo",
  "clearTheRangeToSelectOptions": "Borrar el rango para seleccionar opciones.",
  "clearTheSearchBar": "Borrar la barra de búsqueda",
  "conductASearch": "Realizar una búsqueda",
  "currentLocation": "Ubicación Actual",
  "didYouMean": "Quisiste decir <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Cuando haya resultados de autocompletar, usa las flechas arriba y abajo para revisar y entra para seleccionar.",
  "feedback": "Comentarios",
  "filterGroupSearchInputLabel": "Buscar opciones de {{title}}",
  "invalidRange": "Rango no válido",
  "max": "Máx.",
  "min": "Mín.",
  "navigateToTheNextResultsPage": "Navegue a la página de resultados del siguiente",
  "navigateToThePreviousResultsPage": "Navegue a la página de resultados anterior",
  "noAutocompleteOptionsFound": "0 Opciones de autocompletar encontradas.",
  "noAutocompleteSuggestionsFound": "0 Sugerencias de autocompletar encontradas.",
  "noResultsFoundIn": "No se encontraron resultados en {{currentVerticalLabel}}.",
  "paginationPage": "página {{pageNumber}}",
  "pagination": "Paginación",
  "readMoreAbout": "Leer más sobre <a>{{name}}</a>",
  "recentSearch": "búsqueda reciente: {{query}}",
  "recentSearchesFound_many": "{{count}} búsquedas recientes encontradas.",
  "recentSearchesFound_one": "{{count}} búsqueda reciente encontrada.",
  "recentSearchesFound_other": "{{count}} búsquedas recientes encontradas.",
  "removeFilter": "Quitar el filtro «{{displayName}}»",
  "resultPreview": "vista previa de resultados: {{value}}",
  "resultPreviewsFound_many": "{{count}} vistas previas de resultados encontradas.",
  "resultPreviewsFound_one": "{{count}} vista previa de resultado encontrada.",
  "resultPreviewsFound_other": "{{count}} vistas previas de resultados encontradas.",
  "resultsCountText_many": "{{count}} resultados",
  "resultsCountText_one": "{{count}} resultado",
  "resultsCountText_other": "{{count}} resultados",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} de {{resultsCount}} resultados",
  "searchHere": "Buscar aquí…",
  "showingAllInstead": "Mostrando todos los {{currentVerticalLabel}} en su lugar.",
  "showLess": "Mostrar Menos",
  "showMore": "Mostrar Más",
  "sources_many": "Fuentes ({{count}})",
  "sources_one": "Fuente",
  "sources_other": "Fuentes ({{count}})",
  "submitSearch": "Enviar búsqueda",
  "suggestionResultsCount_many": "{{label}} - {{count}} resultados",
  "suggestionResultsCount_one": "{{label}} - {{count}} resultado",
  "suggestionResultsCount_other": "{{label}} - {{count}} resultados",
  "thankYouForYourFeedback": "¡Gracias por tus comentarios!",
  "thisAnsweredMyQuestion": "Esto respondió mi pregunta",
  "thisDidNotAnswerMyQuestion": "Esto no respondió mi pregunta",
  "unselectAnOptionToEnterInARange": "Deselecciona una opción para ingresar un rango.",
  "updateYourLocation": "Actualiza tu ubicación",
  "useCurrentLocation": "Usar Ubicación Actual",
  "useMyLocation": "Usar mi ubicación",
  "viewAll": "Ver todo",
  "viewDetails": "Ver detalles"
}
